import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  flex1: {
    flex: 1
  }
}));

export const Flex1: React.FC = () => {
  const classes = useStyles();
  return <div className={classes.flex1} />;
};
